module.exports = __webpack_public_path__ + "media/images/emblems/Boecourt-9157b778d7a4df3dc895bbb3e2c807bb.png";